export default {
    // API接口基础地址 - 根据环境自动切换
    baseURL: process.env.NODE_ENV === 'development' ? '' : '',

    // API接口路径
    api: {
        // 网站设置相关接口
        settings: {
            public: '/api/settings/public'          // 获取前台公开的网站设置
        },

        // 报告相关接口
        report: {
            search: '/api/reports/search',              // 搜索报告（公开，需 report_number）
            detail: '/api/reports',                     // 获取报告详情 /:id（管理端，需 auth）
            // 公开访问通道（按 report_number，无 token，兼容已印发二维码）
            publicPreview: '/api/reports/public/preview',   // 预览 PDF（?report_number=xxx）
            publicDownload: '/api/reports/public/download'  // 下载 PDF（?report_number=xxx）
        }
    }
} 